import { useForm, useFormState } from 'react-final-form';
import { type FactorialParamsResponse, type FactorialTeam } from 'src/shared/api/integrations/factorial';

export const SELECT_ALL_VALUE = 'all';

export const mapFactorialTeamsToSelect = (data?: FactorialTeam[]) =>
  data?.map(el => ({ label: el.name, value: el.id })) ?? [];

export const useStep3 = (data: FactorialParamsResponse | undefined) => {
  const form = useForm();
  const { values } = useFormState();
  const dataToSelect = mapFactorialTeamsToSelect(data?.teams);
  const allSelected = values?.teams?.length === dataToSelect.length;

  const handleManualChange = (event: React.ChangeEvent<{ value: string }>) => {
    const value = event.target.value;
    if (value[value.length - 1] === SELECT_ALL_VALUE) {
      form.change('teams', allSelected ? [] : dataToSelect.map(({ value }) => value));
      return;
    }
    form.change('teams', value);
  };

  return {
    handleChange: handleManualChange,
    dataToSelect,
    values
  };
};
